import React, { useEffect, useState } from 'react';
import { MinusCircleOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, Input, Row, Select, Space } from 'antd';
import accountService from '../../../api/account.service';
import { CR_TAG, DR_TAG, SUCCESS_STATUS } from '../../../utility/Constants';
import commonUtility from '../../../utility/Utils';
import { Fragment } from 'react';
const { Option } = Select;

const AccountDrCrDetailsGeneral = (props) => {
    

    const [accountList, setAccountList] = useState([]);
    const [defaultDrCrTag, setDefaultDrCrTag] = useState("");

    const [inputFields, setInputFields] = useState([
        { ac_tag: '', account_id: '' , amount : 0 }
      ]);

    useEffect(() => {
        accountService.accountListForJournal().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);



    useEffect(() => {
        if(props.transTag=="RC"){
            setDefaultDrCrTag(CR_TAG)
        }
        else{
            setDefaultDrCrTag(DR_TAG)
        }
       
    },[props.transTag]);


    const testadd = () => {
        console.log("Add")
    }

  

    return (
            <>

            <h4 style={{marginTop:'10px'}}>Account Details</h4>
            <Divider />
            <Form.List  name="voucher_details" >

                {(fields, { add , remove }) => (
                    <>
                        {fields.map((field , index )  => (

                            <Row gutter={20} key={`accountdetailrow_${index}`}>
                                <Col xs={24} xl={4}>
                                    <Form.Item
                                        {...field}
                                        label={`Tag`}
                                        name={[field.name, 'ac_tag']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Dr/Cr Tag required',
                                            },
                                        ]}
                                        
                                 
                                    >
                                        <Select 
                                       
                                        >
                                            <Option key="DrTag" value="Dr" >Dr</Option>
                                            <Option key="CrTag" value="Cr">Cr</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={12}>
                                    <Form.Item
                                        {...field}
                                        label="Account"
                                        name={[field.name, 'account_id']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Account required',
                                            },
                                        ]}


                                    >
                                        <Select
                                            className="text-left"
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            allowClear={true}
                                        >

                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }


                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={6}>
                                    <Form.Item
                                        {...field}
                                        label="Amount"
                                        name={[field.name, 'amount']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Amount Required',
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={2}>


                                    <Form.Item
                                        {...field}
                                        label=" "
                                        name={[field.name, 'action']}

                                    >
                                        <Button
                                            type="danger"
                                            icon={<DeleteOutlined />}
                                            shape="circle"
                                            onClick={() => props.removeDetail(index)}
                                            />
                                    </Form.Item>

                                </Col>
                            </Row>



                        ))}

                        <Form.Item>
                            <Button shape='round' className='custom-button-green' onClick={() => testadd()} block icon={<PlusOutlined />}>
                                Add Account Details
                            </Button>
                        </Form.Item>
                    </>
                )}
                








                 {
                    /**
                     * 
                     */

                 }








            </Form.List>
            </>
            

     
    );
};
export default AccountDrCrDetailsGeneral;